// src/components/FeedbackDashboard.js
import React, { useState, useEffect } from "react";
import SurveyForm from "../uicomponent/surveyform";
import axios from "axios";
import "./FeedbackDashboard.css";

const FeedbackDashboard = () => {
  //const [mode, setMode] = useState(""); // self | peer | reportee
  const [feedbackType, setFeedbackType] = useState("self"); // "self" | "peer"
  const [peers, setPeers] = useState([]);
  const [reportees, setReportees] = useState([]);
  const [selectedTarget, setSelectedTarget] = useState(null);

  const userId = localStorage.getItem("userId");
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");

  // Fetch peers or reportees dynamically
  useEffect(() => {
    if (role === "Reportee") {
      axios
        .get(`/api/users/${userId}/peers`)
        .then((res) => setPeers(res.data))
        .catch((err) => console.error("Error fetching peers:", err));
    }

    if (role === "Manager") {
      axios
        .get(`/api/users/${userId}/reportees`)
        .then((res) => {
          setReportees(res.data);
          
          //if (res.data.length > 0) {
            // 👇 auto-select first reportee so survey loads immediately
            //setSelectedTarget(res.data[0].id);
          //}
        })
        .catch((err) => console.error("Error fetching reportees:", err));
    }
  }, [role, userId]);

  /*const handleModeChange = (e) => {
    setMode(e.target.value);
    setSelectedTarget(null); // reset dropdown when switching
  };*/
  const handleFeedbackTypeChange = (e) => {
    setFeedbackType(e.target.value);
    setSelectedTarget(null);
  };


  const handleTargetChange = (e) => {
    // ensure selectedTarget is a number
    setSelectedTarget(Number(e.target.value));
  };
  const selectedReporteeName =
    reportees.find((r) => r.id === selectedTarget)?.username || "";
  const selectedPeerName =
    peers.find((p) => p.id === selectedTarget)?.username || "";

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h2>Welcome, {username}</h2>
        <p>Role: {role}</p>
      </header>

      <div className="dashboard-content">
        {/* Left sidebar */}
        <div className="feedback-sidebar">
          {role === "Reportee" && (
            <>
              <h3>Select Feedback Type</h3>
              <label>
                <input
                  type="radio"
                  name="feedbackType"
                  value="self"
                  checked={feedbackType === "self"}
                  onChange={handleFeedbackTypeChange}
                />
                Self
              </label>

              {peers.length > 0 && (
                <label>
                  <input
                    type="radio"
                    name="feedbackType"
                    value="peer"
                    checked={feedbackType === "peer"}
                    onChange={handleFeedbackTypeChange}
                  />
                  Peer
                </label>
              )}

              {/* Peer dropdown */}
              {feedbackType === "peer" && peers.length > 0 && (
                <div className="dropdown-section">
                  <label>Select Peer: </label>
                  <select
                    onChange={handleTargetChange}
                    value={selectedTarget || ""}
                  >
                    <option value="">-- Select Peer --</option>
                    {peers.map((peer) => (
                      <option key={peer.id} value={peer.id}>
                        {peer.username}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </>
          )}

          {role === "Manager" && reportees.length > 0 && (
            <div className="dropdown-section">
              <label>Select Reportee: </label>
              <select
                onChange={handleTargetChange} value={selectedTarget ?? ""}
              >
                <option value="">-- Please Select --</option>
                {reportees.map((rep) => (
                  <option key={rep.id} value={rep.id}>
                    {rep.username}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* Center survey form */}
        <div className="survey-center">
          {role === "Manager" && (
            <SurveyForm
            mode="reportee"
            targetUserId={selectedTarget || null}
            targetName={
      selectedTarget
        ? reportees.find((r) => r.id === selectedTarget)?.username
        : "" // empty until a reportee is chosen
    }
      />
          )}
        
{/* Reportee gives feedback to self or peer */}
         {role === "Reportee" && (
  <SurveyForm
    mode={feedbackType} // "self" or "peer"
    targetUserId={
      feedbackType === "self" 
        ? userId 
        : selectedTarget // stays null until chosen
    }
    targetName={
      feedbackType === "self"
        ? username
        : peers.find((p) => p.id === selectedTarget)?.username || ""
    }
  />
)}
        </div>

      </div>
    </div>
  );
};

export default FeedbackDashboard;
